/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ROUTES } from '../constants/routes';
import { ICONS } from '../constants/icons';
const bettingTasksTabsPages = [ROUTES.BETTING_TASKS];

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  currentNavBar:
    | {
        title: string;
        imageURL: any;
        pageUrlSegment: string;
        hasInfo: boolean;
        infoMessage: string;
        otherIcon: string | undefined;
      }
    | undefined;

  navBarsWithTitles = [
    {
      title: 'Promo',
      imageURL: ICONS.HEADER_PROMO,
      pageUrlSegment: ROUTES.PROMO,
      hasInfo: false,
      infoMessage: '',
      otherIcon: undefined
    },
    {
      title: 'MaxLoyalty kartica',
      imageURL: ICONS.HEADER_CARD,
      pageUrlSegment: ROUTES.BAR_CODE,
      hasInfo: true,
      infoMessage:
        'Prilikom plaćanja računa pokaži svoj lični bar kod operateru u bilo kom MaxBet lokalu i iskoristi sakupljene bodove za plaćanje dela ili računa u celosti.',
      otherIcon: undefined
    },
    {
      title: 'Lični podaci',
      imageURL: ICONS.PROFILE,
      pageUrlSegment: ROUTES.MY_PROFILE,
      hasInfo: false,
      infoMessage: '',
      otherIcon: undefined
    },
    {
      title: 'Pravila igre',
      imageURL: ICONS.HEADER_GAME_RULES,
      pageUrlSegment: ROUTES.GAME_RULES,
      hasInfo: false,
      infoMessage: '',
      otherIcon: undefined
    },
    {
      title: 'O aplikaciji',
      imageURL: ICONS.HEADER_ABOUT_APP,
      pageUrlSegment: ROUTES.ABOUT_APP,
      hasInfo: false,
      infoMessage: '',
      otherIcon: undefined
    },
    {
      title: 'Uslovi i Politika privatnosti',
      imageURL: ICONS.TERMS_AND_CONDITIONS,
      pageUrlSegment: ROUTES.TERMS_AND_CONDITIONS,
      hasInfo: false,
      infoMessage: '',
      otherIcon: undefined
    },
    {
      title: 'Korisnička podrška',
      imageURL: ICONS.HEADER_SUPPORT,
      pageUrlSegment: ROUTES.SUPPORT,
      hasInfo: false,
      infoMessage: '',
      otherIcon: undefined
    }
  ];

  constructor(private router: Router) {}

  isNotificationPageVisible() {
    return this.getLastUrlSegment() === ROUTES.NOTIFICATIONS;
  }

  decodeUrl(currentUrl: string): string {
    const decodedUrl = decodeURIComponent(currentUrl);
    const segments = decodedUrl.split('/');
    const lastSegment = segments[1];
    return lastSegment;
  }

  getLastUrlSegment() {
    const decodedUrl = decodeURIComponent(this.router.url);
    const segments = decodedUrl.split('/');

    return segments[segments.length - 1];
  }

  setCurrentNavBar() {
    let decodedUrl = decodeURIComponent(this.router.url).slice(1);
    const urlSegments = decodedUrl.split('/');

    if (urlSegments.length > 1) {
      decodedUrl = urlSegments[1];
    }
    this.currentNavBar = this.navBarsWithTitles.find(
      (page: { pageUrlSegment: string | string[] }) => page.pageUrlSegment.includes(decodedUrl)
    );
  }

  setCurrentNavBarInfo(title: any, imageUrl: any) {
    this.currentNavBar!.title = title;
    this.currentNavBar!.imageURL = imageUrl;
  }
}
